// extracted by mini-css-extract-plugin
module.exports = {"lobbyTable":"ChallengesMenu_lobbyTable__N4pvU"};